import React, { useState, useEffect } from 'react';

interface PointsRewardAnimationProps {
  pointsToEarn: number;
  isVisible: boolean;
}

const PointsRewardAnimation: React.FC<PointsRewardAnimationProps> = ({
  pointsToEarn,
  isVisible
}) => {
  const [animationKey, setAnimationKey] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
  if (isVisible && pointsToEarn > 0) {
    setIsAnimating(true);
    setAnimationKey(prev => prev + 1);
  } else {
    setIsAnimating(false);
  }
}, [isVisible, pointsToEarn]);


  if (!isVisible || pointsToEarn <= 0) return null;

  return (
    <>
      <style>{`
        @keyframes containerEntrance {
          0% { 
            transform: scale(0.8) translateY(20px); 
            opacity: 0; 
          }
          100% { 
            transform: scale(1) translateY(0px); 
            opacity: 1; 
          }
        }
        
        @keyframes iconPop {
          0% { 
            transform: scale(0) rotate(-45deg); 
            opacity: 0;
          }
          70% { 
            transform: scale(1.15) rotate(5deg); 
            opacity: 1;
          }
          100% { 
            transform: scale(1) rotate(0deg); 
            opacity: 1;
          }
        }
        
        @keyframes iconFloat {
          0%, 100% { 
            transform: rotate(0deg) translateY(0px); 
          }
          25% { 
            transform: rotate(3deg) translateY(-2px); 
          }
          50% { 
            transform: rotate(0deg) translateY(-4px); 
          }
          75% { 
            transform: rotate(-3deg) translateY(-2px); 
          }
        }
        
        @keyframes textSlideUp {
          0% { 
            transform: translateY(20px); 
            opacity: 0; 
          }
          100% { 
            transform: translateY(0px); 
            opacity: 1; 
          }
        }
        
        @keyframes titlePulse {
          0%, 100% { 
            transform: scale(1); 
          }
          50% { 
            transform: scale(1.03); 
          }
        }
        
        @keyframes numberPop {
          0% { 
            transform: scale(0); 
            opacity: 0;
          }
          70% { 
            transform: scale(1.2); 
            opacity: 1;
          }
          100% { 
            transform: scale(1); 
            opacity: 1;
          }
        }
        
        @keyframes numberGlow {
          0%, 100% { 
            color: #eb8635; 
            text-shadow: 0 0 15px rgba(235, 134, 53, 0.6);
          }
          50% { 
            color: #fdcaa1ff; 
            text-shadow: 0 0 25px #eb8635, 0 0 35px rgba(255, 255, 255, 0.8);
          }
        }
        
        @keyframes fadeIn {
          0% { 
            opacity: 0; 
            transform: translateY(10px);
          }
          100% { 
            opacity: 0.9; 
            transform: translateY(0px);
          }
        }
        
        .points-container {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 16px 20px;
          margin: 0 auto;
          overflow: visible;
          max-width: 300px;
          width: 100%;
          animation: containerEntrance 0.8s ease-out;
          background: transparent;
        }
        
        .text-content {
          text-align: center;
          color: #2A919D;
          animation: textSlideUp 0.8s ease-out 0.4s both;
        }
        
        .title {
          font-size: 16px;
          font-weight: 600;
          margin: 0 0 6px 0;
          color: #2A919D;
          text-shadow: 0 2px 4px rgba(0,0,0,0.3);
          animation: titlePulse 2.5s ease-in-out infinite;
          background: transparent;
        }
        
        .points-number {
          font-size: 28px;
          font-weight: bold;
          margin: 8px 0;
          animation: numberPop 0.6s ease-out 0.6s both;
        }
        
        .points-value {
          animation: numberGlow 3s ease-in-out infinite;
          color: #eb8635;
          font-size: 1.5rem;
          font-style: bold;
        }
        
        .points-text {
          font-size: 18px;
          color: #2A919D;
        }
        
        .description {
          font-size: 13px;
          margin: 6px 0 0 0;
          animation: fadeIn 0.6s ease-out 0.8s both;
          color: #666;
          max-width: 250px;
          line-height: 1.4;
        }
      `}</style>

      <div className="points-container" key={animationKey}>

        {/* Contenu texte */}
        <div className="text-content">
          <h4 className="title">
            Récompense à gagner !
          </h4>
          
          <div className="points-number">
            <span className="points-value">
              +{pointsToEarn}
            </span>
            {' '}
            <span className="points-text">points</span>
          </div>
          
          <p className="description">
            Ces points seront ajoutés à votre compte après validation du paiement
          </p>
        </div>
      </div>
    </>
  );
};

export default PointsRewardAnimation;